import React, { useEffect } from "react";
import PopupFooter from ".";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import iconTileRule from "../../../../../assets/images/Event-2026/RULE.png";
import iconHeadContentRule from "../../../../../assets/images/Event-2026/icon-intro.png";
import { useTranslation } from "react-i18next";
import { Divider } from "antd";
import moment from "moment";
import { getData } from "../../../../../utils/localStorage";
import { HIDDEN_POPUP_RANKING_MINIGAME } from "../../../../../helper/const";
import { useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import { curStateMiniGame } from "../../../../../Redux/selector";
import {
  // getDataAwardListMiniGame,
  getRuleMiniGame,
} from "../../../../../Redux/futures/mini-game/action";
import _ from "lodash";

function checkMonthT9() {
  if (getData("isMonth9")) {
    return true;
  }

  const now = moment(); // thời gian hiện tại
  const target = moment("2025-09-01 00:00:00", "YYYY-MM-DD HH:mm:ss");

  return now.isAfter(target); // true nếu >, false nếu <=
}

export default function PopupRule({ isShowPopupIntro, setIsShowPopupIntro }) {
  const { t } = useTranslation();
  const {
    dataRule = [],
  } = useSelector(curStateMiniGame);
  const dispatch = useDispatch();

  useEffect(() => {
    // if (!dataRule || _.isEmpty(dataRule)) {
    //   dispatch(getRuleMiniGame());
    // }

    // }
  }, []);

  return (
    <div className="popup-minigame__2025">
      <PopupFooter
        isOpen={isShowPopupIntro}
        onClose={() => setIsShowPopupIntro(false)}
        className={"popup-rule-mini rule-scroll"}
      >
        <>
          <div className="header-mini-popup-rule">
            <div className="content-rule-mini">
              <img src={iconTileRule} alt="" />
            </div>
          </div>
          <div className="box-content-minigame-popup__container box-content-minigame-popup__scroll">
            <div className="box_head_content_rule">
              <img src={iconHeadContentRule} alt="" />
              <div>
                <p>Copa Mundial 2026</p>
                <span>Duración del evento</span>
                <b>00:00:01 del 14 de junio de 2026 - 23:59:59 del 19 de julio de 2026</b>
              </div>
            </div>
            <div className="box-content-minigame-popup">
              <div className="title-popup-mini">
                Premios increíbles:
              </div>
              <div className="popup-mini-content" />
              <p>
                El Lego del Trofeo de la FIFA 2026 - S/1339 (1) <br />
                Balón Adidas Trionda Pro FIFA - S/599 (3) <br />
                Balón Adidas Trionda FIFA - S/179 (4) <br />
                5 Minix Copa Mundial - S/119,9 (6) <br />
                Tarjeta de regalo de S/80 (10) <br />
                1 o 2 pujas gratis <br />
                1 o 2 monedas gratis 
              </p>
            </div>
            <div className="box-content-minigame-popup">
              <div className="title-popup-mini">
                Cómo participar:
              </div>
              <div className="popup-mini-content" />
              <p>
                 - Cada usuario recibe <strong>2 monedas gratis</strong> para girar “Copa Mundial 2026”. <br />
                - Los jugadores pueden ganar <strong>Premios Instantáneos</strong> directamente (1 o 2 pujas gratis) o reunir piezas del rompecabezas para canjear <strong>premios mayores</strong> (5 Minix Copa Mundial, Balón Adidas  <br />
                Trionda FIFA, Balón Adidas Trionda Pro FIFA, Lego del Trofeo de la FIFA 2026 y Tarjeta de regalo de S/80).
              </p>
            </div>
            <div className="box-content-minigame-popup">
              <div className="title-popup-mini">
                Formas de ganar monedas adicionales:
              </div>
              <div className="popup-mini-content" />
              <p>
              + Completa misiones <br />
              + Misión diaria: <br />
              Inicio de sesión diario → Gana 2 monedas <br />
              Realiza 3 pujas → Gana 1 moneda <br />
              + Más misiones: <br />
              Compra CHANCE → Gana 1 moneda <br />
              Compra CHANCE2 → Gana 2 monedas <br />
              Compra CHANCE5 → Gana 6 monedas <br />
              Compra CHANCE10 → Gana 12 monedas + 1 supermoneda <br />
              Suscríbete / Renueva el paquete diario → Gana 3 monedas <br />
              Suscríbete / Renueva el paquete semanal → Gana 12 monedas + 2 supermonedas <br />
              Suscríbete / Renueva el paquete mensual → Gana 30 monedas + 5 supermonedas <br />
              + Intercambia pujas por monedas: <br />
              1 puja = 1 moneda <br />
              </p>
            </div>
            <div className="box-content-minigame-popup">
              <div className="title-popup-mini">
                Supermoneda:
              </div>
              <div className="popup-mini-content" />
              <p>
              Cada <strong>supermoneda</strong> desbloquea una pieza aleatoria de los 4 súper premios
              </p>
            </div>
          </div>
        </>
      </PopupFooter >
    </div >
  );
}
